module.exports = __webpack_public_path__ + "static/media/fly0242.98adddee.webp";